import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../api/axios";

const initialState = {
  digitalIdentities: [],
  search: {},
  page: 1,
  morePages: "",
  status: "idle",
  error: null,
};

const fetchDigitalIdentitiesApi = async (filter, signal) => {
  const { code, scope, page, debug } = filter;
  const query = new URLSearchParams({ page, debug }).toString();
  const url = `search/${code}/${scope}?${query}`;
  return await axiosInstance.get(url, { signal });
};
const searchDigitalIdentitiesApi = async (filter, signal) => {
  const { code, scope, type, value } = filter;
  const url = `search/${code}/${scope}/${type}/${value}`;
  return await axiosInstance.get(url, { signal });
};

export const getDigitalIdentities = createAsyncThunk(
  "digitalIdentities/getDigitalIdentities",
  async ({ signal, ...filter }, thunkAPI) => {
    if (filter?.type && filter?.value)
      return await searchDigitalIdentitiesApi(filter, signal);
    return await fetchDigitalIdentitiesApi(filter, signal);
  }
);

const digitalIdentitiesSlice = createSlice({
  name: "digitalIdentities",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDigitalIdentities.pending, (state, action) => {
        state.status = "loading";
        state.digitalIdentities = [];
        if (action?.meta?.arg?.type && action?.meta?.arg?.value)
          state.search = {
            type: action?.meta?.arg?.type,
            value: action?.meta?.arg?.value,
          };
        else state.search = {};
      })
      .addCase(getDigitalIdentities.fulfilled, (state, action) => {
        const resData = action?.payload?.data;
        state.digitalIdentities = resData?.digital_identities;
        state.page = resData?.page;
        state.morePages = resData?.more_pages;
        state.status = "succeeded";
      })
      .addCase(getDigitalIdentities.rejected, (state, action) => {
        if (action.error.code === "ERR_CANCELED") {
          // state.status = "failed";
        } else {
          state.status = "failed";
          state.digitalIdentities = [];
        }
      });
  },
});
export const { setSearch } = digitalIdentitiesSlice.actions;
export default digitalIdentitiesSlice.reducer;

let currentAbortController = null;
export const fetchDigitalIdentities = (filter) => (dispatch) => {
  if (currentAbortController) currentAbortController.abort();
  currentAbortController = new AbortController();
  return dispatch(
    getDigitalIdentities({
      ...filter,
      signal: currentAbortController.signal,
    })
  );
};
